import {
  addDayOffset,
  DateString,
  daysBetween,
  lastSundayDate,
  minDate,
  nextSundayDate,
  thisSundayDate,
} from './date_string.ts';
import { getNameForSunday, isOrdinarySundayName } from './get_name_for_sunday.ts';
import { EventSongList, SongListType } from './model.ts';

export type SongListsByDate = { [date: DateString]: EventSongList[] };

export function getSongListRecurrencesByDate(songLists: EventSongList[], maxDate: DateString): SongListsByDate {
  const result: SongListsByDate = {};
  for (const songList of songLists) {
    result[songList.date] = [songList];
  }
  if (!songLists.find(({ type }) => type === SongListType.Seasonal)) {
    return result;
  }
  const nonOrdinarySundays = getNonOrdinarySundays(songLists, maxDate);
  for (const songList of songLists) {
    const thisSunday = thisSundayDate(songList.date);
    const lastSunday = lastSundayDate(songList.date);
    const thisSundayName = getNameForSunday(thisSunday, { useNameAsType: true });
    const lastSundayName = getNameForSunday(lastSunday, { useNameAsType: true });
    const nearestNonOrdinarySundayDate = nonOrdinarySundays[lastSundayName]
      ? lastSunday
      : nonOrdinarySundays[thisSundayName]
        ? thisSunday
        : undefined;
    if (nearestNonOrdinarySundayDate) {
      const nearestNonOrdinarySundays = nonOrdinarySundays[lastSundayName] ?? nonOrdinarySundays[thisSundayName] ?? [];
      const dayOffset = daysBetween(nearestNonOrdinarySundayDate, songList.date);
      for (const sundayDate of nearestNonOrdinarySundays) {
        const recurrenceDate = addDayOffset(sundayDate, dayOffset);
        //  only play recurrences forward into the future
        if (recurrenceDate <= songList.date) {
          continue;
        }
        if (!result[recurrenceDate]) {
          result[recurrenceDate] = [songList];
        }
      }
    }
  }
  return result;
}

function getNonOrdinarySundays(
  seasonalSongLists: EventSongList[],
  maxDate: DateString,
): { [name: string]: DateString[] } {
  if (seasonalSongLists.length === 0) {
    return {};
  }
  const firstDate = lastSundayDate(minDate(seasonalSongLists.map(({ date }) => date)));
  const result: { [name: string]: DateString[] } = {};
  for (
    let sundayDate = firstDate;
    sundayDate <= addDayOffset(nextSundayDate(maxDate), 7);
    sundayDate = addDayOffset(sundayDate, 7)
  ) {
    const sundayName = getNameForSunday(sundayDate, { useNameAsType: true });
    if (isOrdinarySundayName(sundayName)) {
      continue;
    }
    result[sundayName] = [...(result[sundayName] ?? []), sundayDate];
  }
  return result;
}
